var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"primary align-center d-flex"},[_c('v-card',{staticClass:"ma-auto",attrs:{"width":"400px"}},[_c('v-card-text',[_c('VImg',{staticClass:"ma-auto my-6",attrs:{"src":require('@/assets/images/logo.png'),"alt":"Hexspoor logo","max-width":"70%"}}),_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }